// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_inventory_control_ui_styles" + "." + "eb75237a" + ".chunk.css";
};